var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownloadIconSmallWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.401,
    height: 9.662,
    viewBox: "0 0 10.401 9.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_Icon_Small_White",
    "data-name": "Download Icon Small White",
    transform: "translate(-335.628 -387.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M343.215,391.424H341.6v-2.731a.771.771,0,1,0-1.543,0v2.731h-1.615a.237.237,0,0,0-.167.4l2.386,2.386a.238.238,0,0,0,.335,0l2.386-2.386A.237.237,0,0,0,343.215,391.424Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1756",
    "data-name": "Group 1756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M345.258,397.583H336.4a.772.772,0,0,1-.772-.772V394.6a.772.772,0,1,1,1.544,0v1.435h7.314V394.6a.771.771,0,1,1,1.543,0v2.207A.772.772,0,0,1,345.258,397.583Z",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconSmallWhite);
export default __webpack_public_path__ + "static/media/Download Icon Small White.958f2bf7f935af4828e86c98cdc63570.svg";
export { ForwardRef as ReactComponent };